<template>
  <Dialog
    :title="formType === 'add' ? '新增课件' : '编辑课件'"
    :visible.sync="dialogVisible"
    width="50%"
    :close-on-click-modal="false"
    :before-close="closeDialog"
  >
    <el-form
      label-width="120px"
      :model="wareForm"
      :rules="wareFormRules"
      ref="wareFormRef"
    >
      <el-form-item label="课件名称：" prop="resourceName">
        <el-input
          maxlength="30"
          v-model.trim="wareForm.resourceName"
          placeholder="请输入课件名称"
        />
      </el-form-item>
      <el-form-item label="文件类型：" prop="resourceType">
        <el-select
          v-model="wareForm.resourceType"
          placeholder="请选择文件类型"
          style="width: 100%;"
          @change="handleResourceTypeChange"
        >
          <el-option
            v-for="item in resourceTypeList"
            :key="item.dictValue"
            :label="item.dictLabel"
            :value="item.dictValue"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="文件地址：" prop="urls">
        <el-upload
          class="ware-upload"
          action=""
          drag
          :show-file-list="true"
          :limit="1"
          :file-list="fileList"
          :accept="uploadAccept"
          :disabled="!wareForm.resourceType"
          :before-upload="beforeUpload"
          :on-remove="handleFileRemove"
          :on-exceed="handleExceed"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div slot="tip" class="el-upload__tip">
            请先选择文件类型，再上传对应格式文件；已有文件时重新上传将覆盖
          </div>
        </el-upload>
      </el-form-item>
      <el-form-item>
        <el-button plain round size="small" @click="closeDialog"
          >关闭</el-button
        >
        <el-button
          plain
          round
          size="small"
          type="primary"
          :loading="submitLoading"
          @click="submitForm"
        >
          提交
        </el-button>
      </el-form-item>
    </el-form>
  </Dialog>
</template>

<script>
import { uploadFile } from "@/utils/alioss.js";
import { getIntDictOptions } from "@/utils/dict";

import {
  resolvePreviewType,
  getUploadFolderByPreviewType,
  getAcceptByPreviewType
} from "@/utils/resourcePreview";
import { formatFileSize } from "@/utils/util";

const defaultForm = () => ({
  wareId: "",
  resourceName: "",
  fileName: "",
  resourceType: "",
  urls: "",
  fileSize: null,
  courseCode: "",
  createTime: ""
});

export default {
  name: "WareForm",
  data() {
    const validateResourceName = (rule, value, callback) => {
      if (!value) {
        callback();
        return;
      }
      const name = String(value).trim();
      const currentId = this.wareForm.wareId;
      const duplicated = (this.existingWareList || []).some(item => {
        if (currentId && item.wareId === currentId) return false;
        return String(item.resourceName || "").trim() === name;
      });
      if (duplicated) {
        callback(new Error("该课程下课件名称不能重复"));
        return;
      }
      callback();
    };
    return {
      formType: "add",
      dialogVisible: false,
      submitLoading: false,
      wareForm: defaultForm(),
      fileList: [],
      existingWareList: [],
      wareFormRules: {
        resourceName: [
          { required: true, message: "请输入课件名称", trigger: "blur" },
          { validator: validateResourceName, trigger: "blur" }
        ],
        resourceType: [
          { required: true, message: "请选择文件类型", trigger: "change" }
        ],
        urls: [{ required: true, message: "请上传文件", trigger: "change" }]
      }
    };
  },
  computed: {
    resourceTypeList() {
      return getIntDictOptions("resource_type");
    },
    uploadAccept() {
      const previewType = resolvePreviewType({
        url: this.wareForm.urls,
        resourceType: this.wareForm.resourceType,
        resourceTypeList: this.resourceTypeList
      });
      return getAcceptByPreviewType(previewType);
    }
  },
  methods: {
    formatFileSize,
    handleResourceTypeChange() {
      this.wareForm.urls = "";
      this.wareForm.fileName = "";
      this.wareForm.fileSize = null;
      this.fileList = [];
      this.$nextTick(() => {
        this.$refs.wareFormRef && this.$refs.wareFormRef.validateField("urls");
      });
    },
    handleFileRemove() {
      this.wareForm.urls = "";
      this.wareForm.fileName = "";
      this.wareForm.fileSize = null;
      this.fileList = [];
    },
    // 已有文件时再次选择，覆盖原文件
    handleExceed(files) {
      const file = files && files[0];
      if (!file) return;
      this.fileList = [];
      this.beforeUpload(file);
    },
    async beforeUpload(file) {
      if (!this.wareForm.resourceType) {
        this.$message.warning("请先选择文件类型");
        return false;
      }
      const previewType = resolvePreviewType({
        resourceType: this.wareForm.resourceType,
        resourceTypeList: this.resourceTypeList
      });
      const folder = getUploadFolderByPreviewType(previewType);
      try {
        const res = await uploadFile(folder, file, file.name);
        if (res && res.res && res.res.status == 200) {
          const url = res.res.requestUrls[0];
          this.wareForm.urls = url;
          this.wareForm.fileName = file.name;
          this.wareForm.fileSize = file.size;
          this.fileList = [{ name: file.name, url }];
          this.$nextTick(() => {
            this.$refs.wareFormRef &&
              this.$refs.wareFormRef.validateField("urls");
          });
        }
      } catch (e) {}
      return false;
    },
    async submitForm() {
      if (this.submitLoading) return;
      try {
        await this.$refs.wareFormRef.validate();
      } catch (e) {
        return;
      }
      this.submitLoading = true;
      try {
        this.$emit("success", {
          type: this.formType,
          wareId: this.wareForm.wareId,
          data: { ...this.wareForm }
        });
        this.closeDialog();
      } catch (e) {
      } finally {
        this.submitLoading = false;
      }
    },
    open(type, row = {}, existingList = []) {
      this.formType = type;
      this.existingWareList = Array.isArray(existingList) ? existingList : [];
      if (type === "edit") {
        this.wareForm = { ...defaultForm(), ...row };
        this.fileList = row.urls
          ? [{ name: row.fileName || row.resourceName, url: row.urls }]
          : [];
      } else {
        this.wareForm = { ...defaultForm(), ...row };
        this.fileList = [];
      }
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.wareFormRef && this.$refs.wareFormRef.clearValidate();
      });
    },
    closeDialog() {
      this.$refs.wareFormRef && this.$refs.wareFormRef.resetFields();
      this.wareForm = defaultForm();
      this.fileList = [];
      this.existingWareList = [];
      this.dialogVisible = false;
    }
  }
};
</script>

<style scoped lang="less">
.ware-upload {
  width: 100%;

  /deep/ .el-upload {
    width: 100%;
  }

  /deep/ .el-upload-dragger {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/CourseEdit/components/WareForm.vue